export default "__VITE_ASSET__BuhsbNxj__"